import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import styles from './CSS/UserContentForm.module.css';
import { useAuth } from '../../../hooks/useAuth';
import { toast } from 'react-toastify';
import Loading from '../../../common/HousGlass Loader/Loading';

function UserContentForm() {
  const initialFormState = {
    name: '',
    email: '',
    password: '',
    role: '',
    agreeToTerms: true
  };

  const [formData, setFormData] = useState(initialFormState);
  const [showPassword, setShowPassword] = useState(false);
  
  // Get the credentialSignup function from useAuth
  const { credentialSignup, isLoading } = useAuth();
    
  const handleSubmit = async(e) => {
    e.preventDefault();
    
    try {
      // Use credentialSignup instead of signup
      await credentialSignup(formData);
      
      // On success, reset the form
      setFormData(initialFormState);
      
      toast.success('Credential signup successful! Your account has been created.');
    } catch (err) {
      toast.error(err?.message || 'Signup failed. Please try again.');
      console.error('Signup error:', err);
    }
  };
  
  if(isLoading) return <div><Loading/></div>;
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.formWrapper}>
        <form onSubmit={handleSubmit} className={styles.form}>
          <h2 className={styles.title}>User Registration</h2>
          
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="name">
              Username
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your name"
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your email"
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="password">
              Password
            </label>
            <div className={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={styles.input}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className={styles.passwordToggle}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>
          
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="role">
              Role
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              className={`${styles.input} ${styles.selectClass} custom-class`}
              required
            >
              <option value="">Select a role</option>
              <option value="admin">Author</option>
              <option value="user">User</option>
              <option value="super_admin">Admin</option>
            </select>
          </div>
          
          <button type="submit" className={styles.submitButton}>
            Register Account
          </button>
        </form>
      </div>
    </div>
  );
}

export default UserContentForm;